import {createAsyncThunk, createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {
    getSmartReportSettingsApi,
    getSmartReportModuleColumnsApi,
    generateSmartReportApi,
    getSmartReportHistoryApi,
    getSmartReportByIdApi,
    deleteSmartReportApi,
} from "../../../../services/report";

export const getSmartReportSettings = createAsyncThunk('report/smart-reports/settings', async (data, {dispatch}) => {
    const response = await getSmartReportSettingsApi();
    return response.response;
});

export const getSmartReportModuleColumns = createAsyncThunk('report/smart-reports/module-columns', async (moduleKey, {dispatch}) => {
    const response = await getSmartReportModuleColumnsApi(moduleKey);
    return response.response;
});

export const generateSmartReport = createAsyncThunk('report/smart-reports/generate', async (data, {dispatch}) => {
    const response = await generateSmartReportApi(data);
    return response.response;
});

export const getSmartReportHistory = createAsyncThunk('report/smart-reports/history', async (data, {dispatch}) => {
    const response = await getSmartReportHistoryApi(data);
    dispatch(setTableRowCount(response.response.count));
    return response.response.data;
});

export const getSmartReportById = createAsyncThunk('report/smart-reports/show', async (id, {dispatch}) => {
    const response = await getSmartReportByIdApi(id);
    return response.response;
});

export const deleteSmartReport = createAsyncThunk('report/smart-reports/delete', async (id, {dispatch}) => {
    const response = await deleteSmartReportApi(id);
    return id;
});

const smartReportAdapter = createEntityAdapter({});

export const {selectAll: selectSmartReports, selectById: selectSmartReportById} = smartReportAdapter.getSelectors(
    state => state.report.smartReport
);

const smartReportSlice = createSlice({
    name: 'smartReport',
    initialState: smartReportAdapter.getInitialState({
        tableRowCount: 0,
        settings: {
            sellers: [],
            partners: [],
            modules: [],
            delivery_partners: [],
            countries: [],
            categories: [],
            sub_categories: [],
            return_reasons: [],
            seasons: [],
            types: [],
            commodities: [],
            seller_brands: [],
            colours: [],
            shippings: [],
            styles: [],
            collections: [],
            admin_reasons: [],
            customer_reasons: [],
        },
        moduleColumns: null,
        columnGroups: [],
        moduleFilters: [],
        searchPlaceholder: null,
        excludePartnerIds: [],
        onlyPartnerIds: [],
        onlySellerIds: [],
        currentReport: null,
        generating: false,
    }),
    reducers: {
        setTableRowCount: (state, action) => {
            state.tableRowCount = action.payload;
        },
        setCurrentReport: (state, action) => {
            state.currentReport = action.payload;
        },
        setGenerating: (state, action) => {
            state.generating = action.payload;
        },
        clearModuleColumns: (state) => {
            state.moduleColumns = null;
            state.columnGroups = [];
            state.moduleFilters = [];
            state.searchPlaceholder = null;
        },
    },
    extraReducers: {
        [getSmartReportSettings.fulfilled]: (state, action) => {
            state.settings = action.payload;
        },
        [getSmartReportModuleColumns.fulfilled]: (state, action) => {
            state.moduleColumns = action.payload;
            state.columnGroups = action.payload.column_groups || [];
            state.moduleFilters = action.payload.filters || [];
            state.searchPlaceholder = action.payload.search_placeholder || null;
            state.excludePartnerIds = action.payload.exclude_partner_ids || [];
            state.onlyPartnerIds = action.payload.only_partner_ids || [];
            state.onlySellerIds = action.payload.only_seller_ids || [];
        },
        [getSmartReportHistory.fulfilled]: smartReportAdapter.setAll,
        [generateSmartReport.fulfilled]: (state, action) => {
            state.generating = true;
            state.currentReport = action.payload;
        },
        [getSmartReportById.fulfilled]: (state, action) => {
            state.currentReport = action.payload;
            if (action.payload.status === 'completed' || action.payload.status === 'failed') {
                state.generating = false;
            }
        },
        [deleteSmartReport.fulfilled]: (state, action) => {
            smartReportAdapter.removeOne(state, action.payload);
            state.tableRowCount = state.tableRowCount - 1;
        },
    }
});

export const {setTableRowCount, setCurrentReport, setGenerating, clearModuleColumns} = smartReportSlice.actions;
export default smartReportSlice.reducer;
